module.exports = __webpack_public_path__ + "static/media/logo-blue@200x.c074da0f.png";